var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c("b-breadcrumb", { attrs: { items: _vm.navigationItems } }),
        _vm._v(" "),
        _c(
          "b-container",
          [
            _c("h3", [
              _vm._v(
                "Configuration for " +
                  _vm._s(_vm.paymentType) +
                  " with ID " +
                  _vm._s(_vm.paymentId)
              )
            ]),
            _vm._v(" "),
            _c("edit-alternative-payment-item", {
              attrs: {
                "payment-type": _vm.paymentType,
                "payment-id": _vm.paymentId,
                "client-id": _vm.clientId,
                "configuration-id": _vm.configurationId
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }